import { getFullStory, isFullStoryInstalled } from '.';

// Note that both 'eventName' and 'eventProperties' here must conform to FullStory's requirements,
// otherwise your event will be silently rejected! The requirements are discussed here:
// https://help.fullstory.com/hc/en-us/articles/360020623274#Limitations%20&%20Guidelines
export const sendFullStoryEvent = (
  eventName: string,
  eventProperties: { [key: string]: any } = {}
) => {
  if ((window as any)?.DEBUG) {
    console.info(
      `ℹ️ Would have sent FullStory event "${eventName}"`,
      eventProperties
    );
    return;
  }

  if (!isFullStoryInstalled()) {
    return; // bail silently, we don't want to throw an error here
  }

  getFullStory().event(eventName, eventProperties);
};
